module.exports = ".facet-list-container {\r\n  width: 100%;\r\n}\r\n\r\n.search-button {\r\n  color: #9b9b9b;\r\n\r\n}\r\n\r\n.search-button :hover {\r\n  color: #666666;\r\n}\r\n\r\n.search-button mat-icon {\r\n\r\n}\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fsapplication/facet-list/facet-list.component.css
// module id = ./src/app/fsapplication/facet-list/facet-list.component.css
// module chunks = main